// extracted by mini-css-extract-plugin
export default {"cls1":"PaperPreviewList-cls1__Ew","cls2":"PaperPreviewList-cls2_L9C PaperPreviewList-cls1__Ew"};